// C.1 — каркас фракции Глобал.
// Подключение реализованных Героев + регистрация в EOT/turn_start хуках.

import { mitActive, mitActiveAvailable, mitOnEndOfTurn } from './c1/mit.js';
import { ivActive, ivActiveAvailable, ivOnEndOfTurn } from './c1/iv.js';
import { raynaActive, raynaActiveAvailable, getRaynaActiveTargets, recomputeRaynaAmplifier } from './c1/rayna.js';
import {
  liPulActive as _liPulActive,
  liPulActiveAvailable as _liPulActiveAvailable,
  liPulOnTurnStart, autoResolveLiPulTrigger
} from './c1/li_pul.js';
// C.1: реализации common-юнитов (Гранатёр G-Sec order, Янтарь turn_end, Оникс order).
import './c1/common-units.js';
// C.1: реализации rare/epic/legendary юнитов.
import './c1/units-batch.js';
// Этап 25: импорт actions.js нужен только для registerImplementedAbility-регистрации
// (resolver уже используется из phases.js, но регистрация — топ-уровень).
import './actions.js';

// Re-export новых имён.
export {
  mitActive as globalMitActive,
  mitActiveAvailable as globalMitActiveAvailable,
  ivActive as globalIvActive,
  ivActiveAvailable as globalIvActiveAvailable,
  raynaActive as globalRaynaActive,
  raynaActiveAvailable as globalRaynaActiveAvailable,
  getRaynaActiveTargets as getGlobalRaynaActiveTargets
};
export const getGlobalMitActiveTargets = () => [];
export const getGlobalIvActiveTargets = () => [];
export const getGlobalLiPulActiveTargets = () => [];

// Стратег Ли Пул — активка реализована, триггер picker для UI.
export const globalLiPulActive = _liPulActive;
export const globalLiPulActiveAvailable = _liPulActiveAvailable;

// Регистрация хуков EOT и turn_start для Героев Глобала.
import { registerOnEndOfTurnExtraHandler, registerOnTurnStartExtraHandler, registerUnitSummonedExtraHandler, registerOnUnitDiedExtraHandler } from '../deus/hooks.js';

registerOnEndOfTurnExtraHandler((state) => {
  for (let i = 0; i < state.players.length; i++) {
    mitOnEndOfTurn(state, i);
    ivOnEndOfTurn(state, i);
  }
});

// Райна-усилитель: пересчёт при появлении/смерти/Молчании Героя Райны или
// союзников с Подавлением.
registerOnTurnStartExtraHandler((state) => {
  recomputeRaynaAmplifier(state);
  for (let i = 0; i < state.players.length; i++) {
    const trigResult = liPulOnTurnStart(state, i);
    if (trigResult?.needsPicker) {
      // Бот авто-разрешает (skip); UI должен переопределить вызовом до этого.
      // Если игрок-человек ходит — picker откроется в UI и заблокирует фазу.
      const player = state.players[i];
      if (player?.isBot) autoResolveLiPulTrigger(state, i);
    }
  }
});
import { recomputeSuppression, onSuppressionSourcePlaced, tickSuppressionSilenceExpiry } from '../../keywords/suppression.js';

registerUnitSummonedExtraHandler((state, ownerIdx, card) => {
  recomputeRaynaAmplifier(state);
  // C.1: Подавление — если выставленный юнит источник, line=1 oneshot Молчание.
  if (card && (card.keywords || []).includes('suppression')) {
    onSuppressionSourcePlaced(state, card);
  } else {
    recomputeSuppression(state);
  }
});
registerOnUnitDiedExtraHandler((state) => {
  recomputeRaynaAmplifier(state);
  recomputeSuppression(state);
});

// Тик длительности Молчания от Подавления — в начале хода.
registerOnTurnStartExtraHandler((state) => {
  tickSuppressionSilenceExpiry(state);
});

// Список ID Героев Глобала — для проверок в UI и боте.
export const GLOBAL_HERO_IDS = Object.freeze([
  'global_mit', 'global_iv', 'global_li_pul', 'global_rayna'
]);

// === Backwards-compat для старых имён (до миграции main.js/match.js) ===
// Старые Герои `glb_polkovnik_mit`, `glb_mayor_iv`, `glb_strateg_li_pul`,
// `glb_komissar_yar`, `glb_ofitserskiy_shtab` удалены из дизайна. Стабы тут
// нужны только чтобы не падали импорты в main.js/match.js. Будут удалены
// когда UI Героев перейдёт на новые имена.

// Legacy-имена ссылаются на новые реализации Героев Глобала. main.js/match.js
// импортируют по этим именам — рефакторнём в следующих сессиях.
export const polkovnikMitActive = mitActive;
export const polkovnikMitActiveAvailable = mitActiveAvailable;

export const mayorIvActive = ivActive;
export const mayorIvActiveAvailable = ivActiveAvailable;

export const strategLiPulActive = globalLiPulActive;
export const strategLiPulActiveAvailable = globalLiPulActiveAvailable;

// БУГ.6: алиасы komissarYar* раньше были noop'ами после удаления Комиссара
// Яра в C.1, но HERO_ACTIVE_MAP в engine-bridge.ts для нового Героя
// 'global_rayna' маппил активку именно на эти noop'ы → активка Райны
// в Mini App не работала. Теперь алиасы указывают на реальные функции
// Райны. Имя «komissarYar*» остаётся legacy — будет удалено когда
// engine-bridge переедет на чистые `raynaActive` / `raynaActiveAvailable`.
export const komissarYarActive = raynaActive;
export const komissarYarActiveAvailable = raynaActiveAvailable;
export const getKomissarYarActiveTargets = getRaynaActiveTargets;

// БУГ.7: блок legacy stubs для старых glb_* юнитов и Героев УДАЛЁН.
// Эти карты не существуют в src/data/cards-global.js (миграция C.1 на v6),
// поэтому noop-функции и константы (MEDIK_ID/SAPER_ID/OFITSER_ID/etc)
// больше не нужны. Hero aliases (polkovnikMit*/mayorIv*/strategLiPul*/
// komissarYar*) ОСТАВЛЕНЫ выше как правильные alias'ы на реальные функции
// новых Героев — engine-bridge HERO_ACTIVE_MAP ещё их использует.
